import React from 'react';

//Dependencies.
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';

//Functions.
import { createDynamicStartDate } from '../../../../functions/momentJS';

import "./ActiveChallengeFormInput.styles.css";

const ActiveChallengeFormInputs = ({ activeChallengeEndDateRef, challengeAnnouncementEndDate, challengeEndConditions, setchallengeEndConditions, winningVotesRef }) => {
   const { challengeEndsWhen } = challengeEndConditions;

   return (
      <div style={{ backgroundColor: "lightgoldenrodyellow", margin: '0.5%', padding: '1.5%', borderRadius: '15px' }}>
         <FormGroup style={{backgroundColor: "beige", margin: '0.5%', padding: '1.5%', borderRadius: '15px'}}>
            <Label><strong>Do you want your challenge to end by a certain <span className='text-danger'>date</span> or when a video reaches a certain number of <span className='text-danger'>votes</span>?</strong></Label>
            <Row>
               <Col sm={5}>
                  <Input type='radio' name='challengeEndConditions' id="endDate" value="end date is reached." required onChange={e => setchallengeEndConditions(prvChallengeEndConditions => ({ ...prvChallengeEndConditions, challengeEndsWhen: e.target.value })) } style={{border: "3px solid black"}} />
               </Col>
               <Col sm={7}>
                  {" "} <Label htmlFor='endDAte'>Challenge ends by certain date.</Label>
               </Col>
            </Row> {/* active challenge ends by certain date. */}
            <Row>
               <Col sm={5}>
                  <Input type='radio' name='challengeEndConditions' id="winningVotes" value="winning votes is reached." onChange={e => setchallengeEndConditions(prvChallengeEndConditions => ({ ...prvChallengeEndConditions, challengeEndsWhen: e.target.value })) } style={{border: "3px solid black"}} />
               </Col>
               <Col sm={7}>
                  {" "} <Label htmlFor='endDAte'>Challenge ends by the first video getting a certain number of votes.</Label>
               </Col>
            </Row> {/* active challenge ends by winning number of votes. */}
         </FormGroup> {/* how will the ACTIVE challenge end? */}

         {
            (challengeEndsWhen === "end date is reached.")
            &&
            <FormGroup>
               <Label htmlFor='activeChallengeEndDate'><strong>SELECT AN END DATE FOR YOUR ACTIVE CHALLENGE:</strong></Label>
                  <Input type="date" name='activeChallengeEndDate' id='activeChallengeEndDate' min={
                     challengeAnnouncementEndDate ?
                        createDynamicStartDate(1, challengeAnnouncementEndDate)
                        :
                        createDynamicStartDate(1)
                  } innerRef={activeChallengeEndDateRef} style={{ border: '3px solid black' }} required />
            </FormGroup> //select end date for active challenge.
         }

         {
            (challengeEndsWhen === "winning votes is reached.")
            &&
            <FormGroup>
               <Label htmlFor='winningVotesReached'><strong>SET THE WINNING VOTE FOR YOUR ACTIVE CHALLENGE:</strong></Label>          
               <Input type='number' id='winningVotesReached' innerRef={winningVotesRef} style={{border: '3px solid black'}} required />
            </FormGroup> //enter the votes needed for a video to win & end challenge.
         }         
      </div>
  )
}

export default ActiveChallengeFormInputs